import styled from 'styled-components';
import Form from 'certnd/Form';

export const FormBlock = styled(Form.Block)`
    margin: 0 !important;
    max-width: 100% !important;
`;
